import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';
import { Empty } from 'antd';

const S9PageSection = ui.S9PageSection.default;
const { Grid } = ui;

interface AppointmentSlotsSectionProps {
  eventId?: number;
  bookingType?: string;
}

export function AppointmentSlotsSection({
  eventId,
  bookingType,
}: AppointmentSlotsSectionProps) {
  if (!eventId) {
    return (
      <S9PageSection size="sm">
        <Empty
          description="Save the event first to view appointment slots"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </S9PageSection>
    );
  }

  if (bookingType !== 'Appointment') {
    return (
      <S9PageSection size="sm">
        <Empty
          description="Appointment slots are only available for events with 'Appointment' booking type"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </S9PageSection>
    );
  }

  return (
    <S9PageSection size="sm">
      <Grid
        name="appointment_slots_list"
        searchQueryKey="getappointmentslotsbyeventid"
        queryVars={{
          id: eventId,
          page: 0,
          limit: 100,
          filters: JSON.stringify({}) as never,
        }}
        showTotal
        columnsConfiguration={[
          {
            label: 'ID',
            field: 'id',
            value: '{{id}}',
            renderAs: ColumnConfigurationRenderAs.Text,
            options: {
              linkProp: '/crm/appointment-slots/{{id}}',
            },
          },
          {
            label: 'Start Date & Time',
            field: 'start_dt',
            value: '{{start_dt}}',
            renderAs: ColumnConfigurationRenderAs.Date,
            options: {
              noTime: false,
            },
          },
          {
            label: 'End Date & Time',
            field: 'end_dt',
            value: '{{end_dt}}',
            renderAs: ColumnConfigurationRenderAs.Date,
            options: {
              noTime: false,
            },
          },
          {
            label: 'Available',
            field: 'is_available',
            value: '{{is_available}}',
            renderAs: ColumnConfigurationRenderAs.EnumTags,
            options: {
              enumColor: {
                Yes: 'green',
                No: 'red',
              },
            },
          },
        ]}
      />
    </S9PageSection>
  );
}
